import React from "react";
import { Link } from "react-router-dom";
import "./PressReleases.scss";
import rightArrow from "../../assets/icons-icon-arrow-right@2x.png";
import downArrow from "../../assets/icons-icon-arrow-down.png";
import motif from "../../assets/motiff.png"
import dictionary from "i18next";
import {
  Card,
  CardImg,
  CardText,
  CardTitle,
} from "reactstrap";
class PressReleases extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      start: 0,
      totalNoOfRows:
        props.fields["Press Releases list"] &&
        props.fields["Press Releases list"].length,
      row: 10,
    };
    this.pressRef = React.createRef()
  }

  handleShowMorw = () => {

    this.setState((prevState) => {
      return {
        start: prevState.start + this.state.row,
      };
    });
    this.pressRef.current.scrollIntoView()

  };

  render() {
    let start = this.state.start;
    let end =
      start + this.state.row > this.state.totalNoOfRows
        ? this.state.totalNoOfRows
        : start + this.state.row;
    const pressReleaseData = this.props.fields["Press Releases list"];

    return (
      <>
        <div className="press-center-release-wrapper" ref={this.pressRef}>
          <div className="press-center-description">
            {this.props.fields["Description"].value}
          </div>
          {pressReleaseData.length > 0 &&
            pressReleaseData.slice(start, end).map((item, index) => {
              const title = item.fields["Title"].value;
              const description = item.fields["Tagline"].value;
              const img = item.fields["Hero Image"].value.src;
              return (
                <div
                  className="press-release-list-item row"
                  key={index}
                  style={{ borderTop: start === 0 ? "1px solid #8f8f8f" : "none" }}
                >
                  <div className="col-4 press-release-item-img">
                    <CardImg src={img} />
                  </div>
                  <div className="col-8 press-list-item-info">
                    <h3>{title}</h3>
                    <p>{description}</p>
                    <Link to={item.fields["CTA link"].value.href}>
                      {dictionary.t("PressReleases-ReadMore", "READ MORE")}
                      <img src={rightArrow} />
                    </Link>
                  </div>
                </div>
              );
            })}
          {this.state.start + this.state.row < this.state.totalNoOfRows &&
            <a className="view-more-btn" onClick={this.handleShowMorw}>
              {dictionary.t("PressReleases-ViewMore", "VIEW MORE")} <img alt="right" src={rightArrow} />
            </a>}


        </div>
        <div className="press-center-motif">
          <div className="motif-below" style={{ backgroundImage: `url(${motif})` }} />
        </div>
      </>
    );
  }
}

export default PressReleases;
